module.exports = __webpack_public_path__ + "img/signal-stream-slash.326e6d08.svg";